import { IMAGE_QUALITY_DESKTOP } from "@/lib/heroImageUtils"

// takes any type of entry and the site config.
export const getTeaserImageUrlByEntry = (
  entry: any,
  config: any,
  width: number = 413,
  height: number = 200,
  useFallback: boolean = true,
) => {
  const fallback = useFallback
    ? config?.commonDefaultValues?.fallbackImageForCards?.url || null
    : null
  let teaserImage = fallback

  // RC entries: teaserImage has a flat url
  if (entry?.articleSeo?.teaserImage?.url) {
    teaserImage = `${entry?.articleSeo?.teaserImage?.url}`
  } else if (entry?.caseStudySeo?.teaserImage?.url) {
    teaserImage = `${entry?.caseStudySeo?.teaserImage?.url}`
  } else if (entry?.seo?.teaserImage?.url) {
    teaserImage = `${entry?.seo?.teaserImage?.url}`
  }
  // MXP entries: teaserImage is a linked image entry with nested .image.url
  else if (entry?.pageSeo?.teaserImage?.image?.url) {
    teaserImage = `${entry?.pageSeo?.teaserImage?.image?.url}`
  } else if (entry?.pageSeoCollection?.items?.[0]?.teaserImage?.image?.url) {
    teaserImage = `${entry?.pageSeoCollection?.items?.[0]?.teaserImage?.image?.url}`
  }

  /* if the image is a BMP, we want to use the fallback */
  if (teaserImage?.includes(".bmp")) {
    teaserImage = fallback
  }

  if (!teaserImage || teaserImage == undefined) return null // Return empty string if no image URL is provided

  const teaserImageThroughAPI = `${teaserImage}?w=${width}&h=${height}&fit=fill&q=${IMAGE_QUALITY_DESKTOP}`

  return teaserImageThroughAPI
}

// if an image URL is provided, it will return the image URL with the specified parameters
export const qualifyImageUrl = (
  imageUrl: string,
  width: number = 413,
  height: number = 200,
  fit?: "fill" | "crop" | "scale" | "pad",
) => {
  if (!imageUrl || imageUrl == undefined) return "" // Return empty string if no image URL is provided
  const fitSetting = fit ? fit : "fill"
  // If the image is a BMP, return nothing.
  if (imageUrl.includes(".bmp")) {
    return ""  
  }

  return `${imageUrl}?w=${width}&h=${height}&fit=${fitSetting}&q=${IMAGE_QUALITY_DESKTOP}`
}
